import * as types from "../constants/ActionTypes";

const show = () => ({ type: types.MUST_UPDATE_PROFILE_SHOW });

export { show };
